import { useEffect, useState } from 'react';

/**
 * Reactive network status. Returns `false` only when the browser/webview is
 * definitively offline (`navigator.onLine === false`). Re-renders on the
 * `online`/`offline` events so offline-aware UI (sidebar filtering, the search
 * palette) updates when connectivity changes.
 */
export function useIsOnline(): boolean {
  const [online, setOnline] = useState(() => (typeof navigator === 'undefined' ? true : navigator.onLine));

  useEffect(() => {
    const goOnline = () => setOnline(true);
    const goOffline = () => setOnline(false);
    window.addEventListener('online', goOnline);
    window.addEventListener('offline', goOffline);
    // Sync once on mount in case it changed before listeners attached.
    setOnline(navigator.onLine);
    return () => {
      window.removeEventListener('online', goOnline);
      window.removeEventListener('offline', goOffline);
    };
  }, []);

  return online;
}
